import React, { useState } from "react";

export default function Home() {
    const storedUsername = localStorage.getItem("quiz_username");
    const [username, setUsername] = useState(storedUsername || "");
    const [loading, setLoading] = useState(false);
    const [isEditing, setIsEditing] = useState(false);

    const handleStart = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!username.trim()) return;

        setLoading(true);
        try {
            const storedUserId = localStorage.getItem("quiz_user_id");
            let userId = storedUserId;

            if (storedUserId) {
                // Update existing user's username if it changed
                const currentStoredUsername = localStorage.getItem("quiz_username");
                if (currentStoredUsername !== username.trim()) {
                    await fetch(`/api/user/${storedUserId}`, {
                        method: "PUT",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ username: username.trim() }),
                    });
                }
            } else {
                // Create new user
                const userRes = await fetch("/api/user", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ username: username.trim() }),
                });
                const user = await userRes.json();
                userId = user.id;
                localStorage.setItem("quiz_user_id", user.id);
            }

            // Create quiz
            const res = await fetch("/api/quiz", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ username: username.trim(), userId }),
            });
            const data = await res.json();

            // Save username to local storage
            localStorage.setItem("quiz_username", username.trim());
            // Redirect to the new quiz URL
            window.location.href = `/quiz/${data.quizId}`;
        } catch (error) {
            console.error("Failed to create quiz:", error);
            setLoading(false);
        }
    };

    const showWelcome = storedUsername && !isEditing;

    return (
        <div className="max-w-md mx-auto bg-white rounded-xl shadow-lg overflow-hidden md:max-w-2xl p-8 text-center mt-10">
            {showWelcome ? (
                <>
                    <p className="text-gray-600 mb-2">
                        Hazır mısın, <span className="font-semibold text-gray-800">{username}</span>?
                        <button
                            type="button"
                            onClick={() => setIsEditing(true)}
                            className="text-blue-600 hover:text-blue-800 ml-1 text-sm"
                        >
                            (Değiştir)
                        </button>
                    </p>
                    <p className="text-gray-600 mb-8">10 zorlu soru seni bekliyor. Bol şans!</p>
                </>
            ) : (
                <>
                    <h2 className="text-3xl font-bold text-gray-800 mb-6">TUS Wars'a Hoş Geldiniz!</h2>
                    <p className="text-gray-600 mb-8">
                        Yeni bir soru düellosu başlatmak için kullanıcı adınızı girin.
                    </p>
                </>
            )}

            <form onSubmit={handleStart} className="space-y-6">
                {!showWelcome && (
                    <div>
                        <input
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            placeholder="Kullanıcı adınızı girin"
                            className="w-full px-4 py-3 rounded-lg border border-gray-300 text-gray-900 focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                            required
                            autoFocus={isEditing}
                        />
                    </div>
                )}

                <button
                    type="submit"
                    disabled={loading || !username.trim()}
                    className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-lg transition duration-300 ease-in-out transform hover:scale-[1.02] disabled:opacity-50 disabled:cursor-not-allowed shadow-md"
                >
                    {loading ? "Yarışma Oluşturuluyor..." : "Yarışmaya Başla"}
                </button>
            </form>
        </div>
    );
}
